<template>
  <Drawer
    width='1050'
    v-model="drawerOpened"
    :title="customerName"
  >
    <div class="drawer-content">
      <CustomerCommentPanel :customer="currentCustomer" ref="CustomerCommentPanel" />
    </div>
  </Drawer>
</template>

<script>
import CustomerCommentPanel from "@/views/ReceiveTaskPage/CustomerCommentPanel.vue";

export default {
  name: 'CustomerCommentDrawer',
  components: {
    CustomerCommentPanel,
  },
  
  data() {
    return {
      drawerOpened: false,
      currentCustomer: null,
      customerName: null,
    };
  },
  methods: {
    async openDrawer(data) {
      this.currentCustomer = data
      this.customerName = data.customer.abbr ? data.customer.abbr : data.customer.name
      this.drawerOpened = true;
    },
  }
};
</script>
<style lang="stylus" scoped>

</style>